import { UserRole } from "tm-shared/types";

const MANAGER_ROLES: UserRole[] = [UserRole.Sv, UserRole.Svm];

export const isManagerRole = (role: UserRole): boolean =>
    MANAGER_ROLES.includes(role);
